module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods"
  }, [_c('div', {
    ref: "menuWrapper",
    staticClass: "menu-wrapper"
  }, [_c('ul', _vm._l((_vm.goods), function(item, index) {
    return _c('li', {
      class: index === _vm.menuCurrentIndex ? 'menu-item-selected' : 'menu-item',
      on: {
        "click": function($event) {
          _vm.menuClick(index)
        }
      }
    }, [_c('span', {
      staticClass: "text"
    }, [_c('support-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type > 0),
        expression: "item.type>0"
      }],
      attrs: {
        "supportType": item.type,
        "iconType": 4
      }
    }), _vm._v("\n          " + _vm._s(item.name) + "\n        ")], 1)])
  }))]), _vm._v(" "), _c('div', {
    ref: "foodsWrapper",
    staticClass: "foods-wrapper",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('ul', _vm._l((_vm.goods), function(item) {
    return _c('li', {
      staticClass: "food-list food-list-hook"
    }, [_c('h1', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('ul', _vm._l((item.foods), function(food) {
      return _c('li', {
        staticClass: "food-item",
        on: {
          "click": function($event) {
            _vm.showFoodDetails(food)
          }
        }
      }, [_c('div', {
        staticClass: "icon"
      }, [_c('img', {
        attrs: {
          "width": "57",
          "height": "57",
          "src": food.icon
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('h2', [_vm._v(_vm._s(food.name))]), _vm._v(" "), _c('p', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (food.description),
          expression: "food.description"
        }],
        staticClass: "description"
      }, [_vm._v(_vm._s(food.description))]), _vm._v(" "), _c('div', {
        staticClass: "sell-info"
      }, [_c('span', {
        staticClass: "sellCount"
      }, [_vm._v("月售" + _vm._s(food.sellCount) + "份")]), _vm._v(" "), _c('span', {
        staticClass: "rating"
      }, [_vm._v("好评率")])]), _vm._v(" "), _c('div', {
        staticClass: "price"
      }, [_c('span', {
        staticClass: "newPrice"
      }, [_c('span', {
        staticClass: "unit"
      }, [_vm._v("￥")]), _vm._v(_vm._s(food.price))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (food.oldPrice),
          expression: "food.oldPrice"
        }],
        staticClass: "oldPrice"
      }, [_vm._v("￥{food.oldPrice}}")])]), _vm._v(" "), _c('div', {
        staticClass: "cartcontrol-wrapper"
      }, [_c('cart-control', {
        attrs: {
          "food": food
        }
      })], 1)])])
    }))])
  }))]), _vm._v(" "), _c('shop-cart'), _vm._v(" "), (_vm.selectedFood) ? _c('food-details', {
    ref: "foodDetails",
    attrs: {
      "food": _vm.selectedFood
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26ecea86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Goods.vue
// module id = 237
// module chunks = 1